import { a as r, I as t, j as a, d as e } from "./IconTemplate-c24f5ddb.mjs";
import "react";
const o = (l) => /* @__PURE__ */ r(t, { ...l, name: l.name || "Failure", viewBox: "0 0 1024 1024", children: [
  /* @__PURE__ */ a(
    "path",
    {
      d: "M313.3 373.65 451.65 512 313.3 650.35l60.35 60.35L512 572.33 650.35 710.7l60.33-60.35L572.33 512 710.7 373.65l-60.35-60.35L512 451.67 373.65 313.3z",
      fill: "currentColor",
      fillOpacity: "0.9"
    }
  ),
  ",",
  /* @__PURE__ */ a(
    "path",
    {
      d: "M1024 512c0 282.77-229.23 512-512 512S0 794.77 0 512 229.23 0 512 0s512 229.23 512 512m-85.33 0c0-235.65-191.02-426.67-426.67-426.67S85.33 276.35 85.33 512 276.35 938.67 512 938.67 938.67 747.65 938.67 512",
      fill: "currentColor",
      fillOpacity: "0.9"
    }
  )
] });
o.defaultProps = e;
export {
  o as default
};
